import { ReactNode } from 'react';
import { Formik, Form, FormikHelpers } from 'formik';
import { AnyObject } from 'yup';

interface Props<T extends AnyObject> {
    children: ReactNode;
    initialValues: T;
    validationSchema?: unknown; // ObjectSchema<Partial<T>>;
    onSubmit: (values: T, helpers: FormikHelpers<T>) => void | Promise<void>;
    enableReinitialize?: boolean;
}

const FormWrapper = <T extends AnyObject>({
    children,
    initialValues,
    validationSchema,
    onSubmit,
    enableReinitialize = false,
}: Props<T>) => {
    return (
        <Formik<T>
            enableReinitialize={enableReinitialize}
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
        >
            <Form>{children}</Form>
        </Formik>
    );
};

export default FormWrapper;
